import { supabase } from '../supabase';

// Strip +, spaces, dashes so +56... and 56... are the same
function normalizePhone(phone: string): string {
  return phone.replace(/[\s\-\+]/g, '');
}

export interface WhatsAppContact {
  id: number;
  user_id: number;
  phone_number: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export const getWhatsAppContacts = async (): Promise<WhatsAppContact[]> => {
  const { data, error } = await supabase
    .from('agent_whatsapp_contacts')
    .select('*');

  if (error) throw error;
  return data || [];
};

export const createWhatsAppContact = async (params: {
  user_id: number;
  phone_number: string;
}): Promise<WhatsAppContact> => {
  const { data, error } = await supabase
    .from('agent_whatsapp_contacts')
    .insert({ ...params, phone_number: normalizePhone(params.phone_number) })
    .select()
    .single();

  if (error) throw error;
  return data;
};

export const updateWhatsAppContact = async (
  id: number,
  params: { phone_number?: string; is_active?: boolean }
): Promise<WhatsAppContact> => {
  const { data, error } = await supabase
    .from('agent_whatsapp_contacts')
    .update({
      ...params,
      ...(params.phone_number ? { phone_number: normalizePhone(params.phone_number) } : {}),
      updated_at: new Date().toISOString(),
    })
    .eq('id', id)
    .select()
    .single();

  if (error) throw error;
  return data;
};

export const deleteWhatsAppContact = async (id: number): Promise<void> => {
  const { error } = await supabase
    .from('agent_whatsapp_contacts')
    .delete()
    .eq('id', id);

  if (error) throw error;
};
